/**
 * FeatureAreasLegend - Фильтры для слоя «Фиче-зоны» (DA-15115)
 *
 * Read-only справочный слой (public.feature_area). 3 тумблера по статусу зоны:
 * ACTIVE / INACTIVE / DELETED — управляют видимостью через mapFilters.featureAreasStatuses.
 */

import { t } from '@lingui/macro';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeFeatureAreasFilter } from '../../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const STATUS_ITEMS = [
    { value: 'ACTIVE', color: '#2ecc71', getLabel: () => t`Активные` },
    { value: 'INACTIVE', color: '#95a5a6', getLabel: () => t`Неактивные` },
    { value: 'DELETED', color: '#e74c3c', getLabel: () => t`Удалённые` },
];
const FeatureAreasFiltersComponent = ({ mapFilters, onChangeFeatureAreasFilter }) => (
    <div>
        <div className={styles.legHead}>{t`Статус`}:</div>
        <div className={classnames(styles.checkboxIconGrid, styles.checkboxIconGridLarge)}>
            {STATUS_ITEMS.map(({ value, color, getLabel }) => (
                <React.Fragment key={value}>
                    <svg
                        viewBox="0 0 32 24"
                        aria-hidden="true"
                        style={{ width: '20px', height: '15px' }}
                    >
                        <rect
                            x="2"
                            y="2"
                            width="28"
                            height="20"
                            fill={color}
                            fillOpacity="0.3"
                            stroke={color}
                            strokeWidth="2.5"
                            strokeOpacity="0.9"
                            rx="2"
                        />
                    </svg>
                    <label htmlFor={`dev-feature-areas-${value}`}>{getLabel()}</label>
                    <div>
                        <label className={styles.switch}>
                            <input
                                type="checkbox"
                                name="featureAreasStatuses"
                                id={`dev-feature-areas-${value}`}
                                checked={mapFilters.featureAreasStatuses.includes(value)}
                                value={value}
                                onChange={onChangeFeatureAreasFilter}
                            />
                            <span className={classnames(styles.sliderRound, styles.slider)} />
                        </label>
                    </div>
                </React.Fragment>
            ))}
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeFeatureAreasFilter })(FeatureAreasFiltersComponent);

export const FeatureAreasLegend = withDisplayedLayersCheck(ConnectedComponent, t`Фиче-зоны`);
